// extracted by mini-css-extract-plugin
module.exports = {"root":"IconDisputeOrder_root__18IYo"};